import { render, staticRenderFns } from "./HomeAdvantagesWidget.vue?vue&type=template&id=66f37799&"
import script from "./HomeAdvantagesWidget.vue?vue&type=script&lang=js&"
export * from "./HomeAdvantagesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/DIA-stylebreaker-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66f37799')) {
      api.createRecord('66f37799', component.options)
    } else {
      api.reload('66f37799', component.options)
    }
    module.hot.accept("./HomeAdvantagesWidget.vue?vue&type=template&id=66f37799&", function () {
      api.rerender('66f37799', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/home/HomeAdvantagesWidget.vue"
export default component.exports